import React from "react";
import { ReactNode } from "react";
interface ModalProps {
  title: string;
  body: ReactNode;
  handleClosePopup?: () => void;
}

const ModalPopup: React.FC<ModalProps> = ({ title, body, handleClosePopup}) => {
  
  return (
    <div className="modal" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title text-blue">{title}</h4>
            <button
              type="button"
              className="btn-close shadow-none"
              data-bs-dismiss="modal"
              onClick={handleClosePopup}
              title="Close"
            />
          </div>
          <div className="modal-body">{body}</div>
          <div className="modal-footer border-0 py-0"></div>
        </div>
      </div>
    </div>
  );
};

export default ModalPopup;
